import { getUrlQueryParam } from '@/utils/urlQueryStringUtils';

class FeatureManager {
  static get STORAGE_NAMESPACE() { return '_aff_experimental_features_'; }

  static get ENABLE_FEATURES_QUERY_PARAM() { return 'enableFeatures'; }

  static get storage() { return window.sessionStorage; }

  static enableFeature(featureCode) {
    this.validateFeatureCode(featureCode);

    const enabledFeatures = this.getEnabledFeatures();

    enabledFeatures[featureCode] = true;
    this.storage.setItem(this.STORAGE_NAMESPACE, JSON.stringify(enabledFeatures));
  }

  static getEnabledFeatures() {
    const storageFeatures = this.storage.getItem(this.STORAGE_NAMESPACE);
    return storageFeatures ? JSON.parse(storageFeatures) : {};
  }

  static loadTemporaryFeatures() {
    const featuresQueryString = getUrlQueryParam(this.ENABLE_FEATURES_QUERY_PARAM);
    if (featuresQueryString) {
      const featuresToEnable = featuresQueryString.split(',');
      featuresToEnable.forEach(featureCode => this.enableFeature(featureCode));
    }
  }

  static validateFeatureCode(featureCode) {
    if (!/^\w+$/.test(featureCode)) throw new Error(`Feature code só deve ter letras, números e underline (_). [${featureCode}]`);
  }
}

export default FeatureManager;
